import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import vsDarkTheme from "../theme/vsDarkTheme";
import TypewriterText from "./TypewriterText";
import TypewriterHeader from "./TypewriterHeader";

const SectionContent = ({ title, content }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box p={{ xs: 1, sm: 2 }}>
      <TypewriterHeader title={title} speed={80} delay={200} />
      <Box sx={{ ml: { xs: 1, sm: 2 } }}>
        <Typography 
          variant="body1" 
          sx={{ 
            fontSize: { xs: '0.875rem', sm: '1rem' },
            lineHeight: 1.6,
            color: vsDarkTheme.palette.keyword.main
          }}
        >
          <span style={{ color: vsDarkTheme.palette.keyword.main }}>return</span>{" "}(<br />
        </Typography>
        <Box sx={{ 
          paddingLeft: { xs: '10px', sm: '20px' },
          display: 'block'
        }}>
          <span style={{ color: vsDarkTheme.palette.string.main }}>`</span>
          <TypewriterText
            text={content}
            speed={20}
            delay={1000}
            sx={{
              color: vsDarkTheme.palette.string.main,
              display: 'inline',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              lineHeight: 1.6,
              wordBreak: 'break-word'
            }}
          />
          <span style={{ color: vsDarkTheme.palette.string.main }}>`</span>
        </Box>
        <Typography 
          variant="body1" 
          sx={{ 
            fontSize: { xs: '0.875rem', sm: '1rem' },
            lineHeight: 1.6,
            color: vsDarkTheme.palette.symbol.main
          }}
        >
          <span style={{ color: vsDarkTheme.palette.symbol.main }}>);</span>
        </Typography>
      </Box>
      <Typography 
        variant={isMobile ? "h6" : "h6"} 
        sx={{ 
          color: vsDarkTheme.palette.comment.main,
          fontSize: { xs: '1rem', sm: '1.25rem' }
        }}
      >
        &#125;
      </Typography>
    </Box>
  );
};

export default SectionContent;
